
import { Component, Watch, Mixins } from 'vue-property-decorator';
import Overview from '@/features/settings/components/notifications/Overview.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component({
  components: {
    Overview,
  },
})
export default class Shipments extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isPobox: {
      show: true,
      name: 'POBox',
    },
    isSignatureComments: {
      show: true,
      name: 'IsSignatureRequested',
    },
    isPickupComments: {
      show: true,
      name: 'IsPickupComments',
    },
    isCallComments: {
      show: true,
      name: 'IsCallRequested',
    },
    isFragileComments: {
      show: true,
      name: 'IsFragile',
    },
    isAdultSignature: {
      show: true,
      name: 'AdultSignatureNA',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isPobox.show = this.searchNotificationPref(
        this.formData.isPobox.name,
      );
      this.formData.isSignatureComments.show = this.searchNotificationPref(
        this.formData.isSignatureComments.name,
      );
      this.formData.isPickupComments.show = this.searchNotificationPref(
        this.formData.isPickupComments.name,
      );
      this.formData.isCallComments.show = this.searchNotificationPref(
        this.formData.isCallComments.name,
      );
      this.formData.isFragileComments.show = this.searchNotificationPref(
        this.formData.isFragileComments.name,
      );
      this.formData.isAdultSignature.show = this.searchNotificationPref(
        this.formData.isAdultSignature.name,
      );
    }
  }
}
